
import { useQuery } from '@tanstack/react-query';
import { fetchAppConfig, DEFAULT_CONFIG } from '../utils/appConfig';

export const useAppConfig = () => {
    const { data: config, isLoading, error } = useQuery({
        queryKey: ['appConfig'],
        queryFn: fetchAppConfig,
        initialData: DEFAULT_CONFIG,
        staleTime: Infinity
    });

    return {
        config: config || DEFAULT_CONFIG,
        isLoading,
        error: error ? (error instanceof Error ? error.message : String(error)) : null
    };
};
